import React, {
  useRef,
  useEffect,
  useState,
  forwardRef
} from 'react';
import { Instagram, YouTube, Facebook } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { motion } from 'framer-motion';

const LandingPage = forwardRef((_, ref) => {
  const bgRef = useRef(null);
  const scrollPos = useRef(0);

  useEffect(() => {
    let ticking = false;

    const updateParallax = () => {
      if (bgRef.current) {
        const translateY = scrollPos.current * 0.4;
        bgRef.current.style.transform = `translateY(${translateY}px)`;
      }
      ticking = false;
    };

    const handleScroll = () => {
      scrollPos.current = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.section
      className="landing-section"
      id="portfolio-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 4 }}
    >
      {/* 🔥 Background Image with Overlay */}
      <div className="parallax-bg" ref={bgRef}>
        <img
          className="bg-image"
          src="https://res.cloudinary.com/navarrojalen/image/upload/v1751352025/mern_uploads/vqg9ygljlrcw6mbnynwo.jpg"
          alt="Background"
        />
        <div className="overlay" />
      </div>

      <div className="landingMainDiv">
        <div className="landingContent">
          <div className="landing-sub-section landing-left">
            <p className="landingName">Jalen Navarro</p>
            <div className="landingPosition">Full-Stack Web Developer</div>
            <p className="landingSlogan">
              Your Vision, My Code — From Concept to Launch.
            </p>
          </div>

          <div className="landing-sub-section landing-right">
            <div className="social-links">
              <IconButton className="landingIcon" href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                <Instagram fontSize="large" />
              </IconButton>
              <IconButton className="landingIcon" href="https://www.youtube.com/" target="_blank" rel="noreferrer">
                <YouTube fontSize="large" />
              </IconButton>
              <IconButton className="landingIcon" href="https://www.facebook.com/jalen.nograles/" target="_blank" rel="noreferrer">
                <Facebook fontSize="large" />
              </IconButton>
            </div>

            <button
              className="landingBtn"
              onClick={() =>
                document.getElementById('portfolio-projects')?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              View my Projects
            </button>
          </div>
        </div>
      </div>
    </motion.section>
  );
});

export default LandingPage;
